import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { deleteAnalysis } from '../../../analysis/state/analysis.actions';
import { AnalysisStatus } from '../../../analysis/models/AnalysisStatus';
import { AnalysisType } from '../../../analysis/models/AnalysisType';
import { AnalysisUtils } from '../../../analysis/utils/analysis-utils';

@Component({
    selector: 'delete-analysis-dialog',
    templateUrl: './delete-analysis-dialog.component.html',
    standalone: false
})
export class DeleteAnalysisDialogComponent {
    @Output()
    deleted = new EventEmitter<number>();

    isOpen = false;
    analysisIdPendingDeletion: number | null = null;

    constructor(private readonly store: Store) {}

    open(analysisId: number): void {
        this.analysisIdPendingDeletion = analysisId;
        this.isOpen = true;
    }

    onOpenChange(isOpen: boolean): void {
        this.isOpen = isOpen;

        if (!isOpen) {
            this.analysisIdPendingDeletion = null;
        }
    }

    confirm(): void {
        if (this.analysisIdPendingDeletion === null) {
            return;
        }

        this.store.dispatch(deleteAnalysis({ analysisId: this.analysisIdPendingDeletion }));
        const deletedId = this.analysisIdPendingDeletion;
        this.onOpenChange(false);
        this.deleted.emit(deletedId);
    }

    static isDeletionAllowed(
        status: AnalysisStatus | string | undefined,
        analysisType: AnalysisType | string | undefined,
        version?: number | null,
        maxVersion?: number | null
    ): boolean {
        if (!status || !analysisType) {
            return false;
        }

        if (status !== AnalysisStatus.DRAFT) {
            return false;
        }

        if (version != null && maxVersion != null && version !== maxVersion) {
            return false;
        }

        return !(
            AnalysisUtils.isLemoAnalysis(analysisType as AnalysisType) ||
            AnalysisUtils.isMuaAnalysis(analysisType as AnalysisType) ||
            AnalysisUtils.isAvgAnalysis(analysisType as AnalysisType) ||
            AnalysisUtils.isTvgAnalysis(analysisType as AnalysisType)
        );
    }
}
